import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import { makeStyles } from '@mui/styles';
import {
    Container,
} from './styles'

const useStylesFacebook = makeStyles((theme) => ({
    root: {
      position: 'relative',
    },
    bottom: {
      color: theme.palette.grey[theme.palette.mode === 'light' ? 200 : 700],
    },
    top: {
      color: 'green',
      animationDuration: '550ms',
      position: 'absolute',
      left: 0,
    },
    circle: {
      strokeLinecap: 'round',
    },
  }));

  const styles = {
    overlay: {
      position: 'absolute',
      height: '100%',
      width: '100%',
      backgroundColor: 'rgba(255, 255, 255, 0.5)', // Overlay 50%
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top: 0,
      left: 0,
      zIndex: 100,
    }
  };

const Spinner = ({ overlay, size = 40 }) => {
    const classes = useStylesFacebook();    
    return (
        <Container style={overlay ? styles.overlay : null}>
            <div className={classes.root}>
            <CircularProgress
                variant="determinate"
                className={classes.bottom}
                size={size}
                thickness={4}
                value={100}
            />
            <CircularProgress
                variant="indeterminate"
                disableShrink
                className={classes.top}
                classes={{
                circle: classes.circle,
                }}
                size={size}
                thickness={4}
            />
            </div>
        </Container>
      );
};

export default Spinner;